import axios from 'axios';
import React, { Component } from 'react';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import ReactPaginate from 'react-paginate';
import "./hojasestilogestiontitulacion.css";

import * as XLSX from "xlsx-js-style";

const claveApi = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = ApiUrl + "listarcarreras" + claveApi;
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + claveApi;
const urlListaEstudTipoTitulacion = ApiUrl + "reportestudtitulxcarrera" + claveApi;

let listaauxiliar = [];
const itemsPerPage = 10;

export default class ReportEstudTitulacionCarrera extends Component {

    constructor(props) {
        super(props)
        this.state = {
            carrera: [],
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            periodos: [],
            estado: "",
            idPeriodo: "1",
            idCarrera: "1",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }

    componentDidMount() {
        axios.get(baseUrlPeriodos).then(response => {
            const listaperiodos = response.data.data;
            if (listaperiodos.length !== 0) {
                this.setState({ periodos: listaperiodos });
            }
        })

        axios.get(carrerasUrl).then(res => {
            const carrera = res.data;
            this.setState({ carrera });
        })
    }

    //BUSQUEDA......
    filter(event) {
        const text = event.target.value;
        const data = this.state.estud;
        let newData = data.filter(function (item) {
            const campo = (
                item.primer_apellido.toUpperCase() +
                " " +
                item.primer_nombre.toUpperCase() +
                " " +
                item.cedula.toUpperCase()
            );
            return campo.indexOf(text.toUpperCase()) > -1;
        });
        if (text === "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })
    }
    handleChangeEstudTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios.post(urlListaEstudTipoTitulacion, {
            idCarrera: this.state.idCarrera,
            idPeriodo: this.state.idPeriodo
        })
            .then(response => {
                if (response.data.success === true) {
                    listaauxiliar = response.data.data;
                    const estud = response.data.data;
                    this.setState({ estud });

                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({
                        currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset),
                        EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset),
                        pageCount: Math.ceil(listaauxiliar.length / itemsPerPage)
                    });

                } else {
                    this.setState({ estado: "No existe datos para mostrar", estud: [] });
                    swal({
                        text: "No existen datos para mostrar",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            })
            .catch(() => {
                this.setState({ estado: "No existe conexión con el servidor", estud: [] });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        const endOffset = newOffset + itemsPerPage;
        this.setState({
            itemOffset: newOffset,
            currentItems: listaauxiliar.slice(newOffset, endOffset),
            EstudianteBackup: listaauxiliar.slice(newOffset, endOffset),
            pageCount: Math.ceil(listaauxiliar.length / itemsPerPage)
        });
    }

    //Exportar a excel
    exportToExcelEstudTipoT = () => {
        const {
            estud = [],
            idPeriodo,
            idCarrera,
            periodos = [],
            carrera = [],
        } = this.state;

        // Nombres legibles
        const periodoSel = periodos.find(p => String(p.id_periodo_academico) === String(idPeriodo));
        const carreraSel = carrera.find(c => String(c.id_carrera) === String(idCarrera));

        const nomPeriodo = periodoSel?.descripcion_periodo_academico || '-';
        const nomCarrera = carreraSel?.descripcion_carrera || '-';

        const aoa = [
            [{ v: "Reporte de estudiantes de titulación por carrera", s: { font: { bold: true, sz: 12 } } }],
            [
                { v: "Período:", s: { font: { bold: true } } },
                { v: nomPeriodo, s: { font: { bold: false } } }
            ],
            [
                { v: "Carrera:", s: { font: { bold: true } } },
                { v: nomCarrera, s: { font: { bold: false } } }
            ],
            [],
            [
                { v: "Cédula", s: { font: { bold: true } } },
                { v: "Primer Apellido", s: { font: { bold: true } } },
                { v: "Segundo Apellido", s: { font: { bold: true } } },
                { v: "Primer Nombre", s: { font: { bold: true } } },
                { v: "Segundo Nombre", s: { font: { bold: true } } },
                { v: "Tipo Titulación", s: { font: { bold: true } } },
                { v: "Tutor", s: { font: { bold: true } } },
                { v: "Calificación", s: { font: { bold: true } } }
            ]
        ];

        estud.forEach(r => {
            aoa.push([
                r.cedula || '',
                r.primer_apellido || '',
                r.segundo_apellido || '',
                r.primer_nombre || '',
                r.segundo_nombre || '',
                r.tipo_titulacion || '',
                r.tutor || '',
                r.calificacion ? Number(r.calificacion).toFixed(2) : '0.00'
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        // Rango total de la hoja
        const range = XLSX.utils.decode_range(ws['!ref']);

        // === Estilo para título y metadatos (primeras 3 filas) ===
        for (let R = 0; R <= 2; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 0 })];
            if (cell) {
                cell.s = {
                    font: { name: "Calibri", sz: 12, bold: true, color: { rgb: "000000" } },
                    alignment: { horizontal: "left", vertical: "center" }
                };
            }
        }

        // === Estilo cabecera de la tabla (fila 4, índice 4) ===
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cell = ws[XLSX.utils.encode_cell({ r: 4, c: C })];
            if (cell) {
                cell.s = {
                    font: { name: "Calibri", sz: 11, bold: true, color: { rgb: "000000" } },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } }
                    },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }
        }

        // === Bordes y estilo para toda la tabla de datos (desde fila 5 hasta el final) ===
        for (let R = 5; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
                if (cell) {
                    cell.s = {
                        font: { name: "Calibri", sz: 11, bold: false, color: { rgb: "000000" } },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        },
                        alignment: { horizontal: "center", vertical: "center" }
                    };
                }
            }
        }

        // Ajuste de ancho de columnas
        ws['!cols'] = [
            { wch: 14 }, { wch: 16 }, { wch: 18 }, { wch: 16 }, { wch: 18 },
            { wch: 25 }, { wch: 30 }, { wch: 12 },
        ];

        // Crear libro y descargar
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte');

        const filename = `reporte-estudiantes_${nomCarrera}_${nomPeriodo}.xlsx`;
        XLSX.writeFile(wb, filename);
    };



    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fas fa-graduation-cap icono-animado"></i>
                        <b className="mb-0 fw-semibold"> Reporte de estudiantes de titulación por carrera</b>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            <div className="col-xl-3">
                                <div className="mb-3">
                                    <label className="form-label"><b>Buscar:</b></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar..."
                                        onChange={(text) => this.filter(text)}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="mb-3">
                                    <label className="form-label"><b>Período</b></label>
                                    <select className="form-select" name="idPeriodo" onChange={this.handleChange}>
                                        <option value="" disabled selected>Seleccione el período</option>
                                        {this.state.periodos.map(periodo =>
                                            <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                                {periodo.descripcion_periodo_academico}
                                            </option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="mb-3">
                                    <label className="form-label"><b>Carrera</b></label>
                                    <select className="form-select" name="idCarrera" onChange={this.handleChangeEstudTipoTitulacion}>
                                        <option value="" disabled selected>Seleccione una carrera</option>
                                        {this.state.carrera.map(person =>
                                            <option key={person.id_carrera} value={person.id_carrera}>
                                                {person.descripcion_carrera}
                                            </option>
                                        )}
                                    </select>
                                </div>
                            </div>

                        </div>

                        <div className="p-3 rounded-3 mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">Reporte de estudiantes</h6>
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr className="text-start text-azul">
                                            <th>Cédula</th>
                                            <th>Primer Apellido</th>
                                            <th>Segundo Apellido</th>
                                            <th>Primer Nombre</th>
                                            <th>Segundo Nombre</th>
                                            <th>Tipo Titulación</th>
                                            <th>Tutor</th>
                                            <th>Calificación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems &&
                                            this.state.currentItems.map((item) => (
                                                <tr key={item.id_estudiante}>
                                                    <td>{item.cedula}</td>
                                                    <td>{item.primer_apellido}</td>
                                                    <td>{item.segundo_apellido}</td>
                                                    <td>{item.primer_nombre}</td>
                                                    <td>{item.segundo_nombre}</td>
                                                    <td>{item.tipo_titulacion}</td>
                                                    <td>{item.tutor}</td>
                                                    <td>{item.calificacion ? Number(item.calificacion).toFixed(2) : "0.00"}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-center mt-4">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm fw-semibold"
                                    onClick={this.exportToExcelEstudTipoT}
                                >
                                    <i className="fas fa-file-excel me-2"></i>
                                    Exportar a Excel
                                </button>
                            </div>
                        </div>

                        <br />
                        <div className="alert alert-info text-azul" role="alert" hidden={this.state.hidden}>
                            {this.state.estado}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
